import { atom } from 'jotai'

export const dismissedCMSContentAtom = atom<string[]>([])
dismissedCMSContentAtom.debugLabel = 'dismissedCMSContentAtom'
